export const PROVIDE_TELEPORT_TARGETS = Symbol('teleportTargets');
